import { useTranslation } from 'react-i18next'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'
import { useEffect, useState } from 'react'
import { ColorHandler, InputBorderHandler } from 'src/utils/style.utils'
import Span from 'src/components/atomic/atom/Span'
import Input from 'src/components/atomic/atom/Input'
import Div from 'src/components/atomic/atom/Div'
import Button from 'src/components/atomic/atom/Button'
import { COLOR } from 'src/constants/colors'
import { Cmdtypes } from 'src/constants/cmdtypes'
import { setCloseModal, setUnlockDeviceInputValue } from 'src/store/Reducer/common/modalSlice'
import { SocketSender } from 'src/api/socket'

const UnLockDeviceModal = () => {
  const { t } = useTranslation()

  const dispatch = useAppDispatch()
  const { isOpen } = useAppSelector((state: RootState) => state.modal)
  const { unlockDeviceInputValue } = useAppSelector((state: RootState) => state.modal)
  const TextLengthValid = unlockDeviceInputValue?.length === 6
  const [textValidCheck, setTextValidCheck] = useState<'default' | 'error' | 'success'>('default')

  const TextValidConfirmHandler = () => {
    if ('unlock' === unlockDeviceInputValue) {
      dispatch(SocketSender(Cmdtypes.UNLOCK_DEVICE))
    } else setTextValidCheck('error')
  }
  const onBlurHandler = () => {
    TextLengthValid ? setTextValidCheck('success') : setTextValidCheck('default')
  }

  useEffect(() => {
    return () => {
      setTextValidCheck('default')
      dispatch(setUnlockDeviceInputValue(''))
    }
  }, [isOpen, dispatch])

  return (
    <>
      <Span option={'medium_bold'}>
        {t('COMMON.UNLOCK_DEVICE', { defaultValue: 'Unlock Device' })}
      </Span>
      <Span option={'tiny'} $margin={'24px 0'}>
        {t('MODAL.UNLOCK_DEVICE.DESC', { defaultValue: 'To unlock your device, enter “unlock”' })}
      </Span>
      <Input
        option={'unLockDevice_modal'}
        value={unlockDeviceInputValue}
        onBlur={onBlurHandler}
        placeholder={'unlock'}
        $border={InputBorderHandler(textValidCheck === 'success', textValidCheck === 'error')}
      />
      {textValidCheck === 'error' && (
        <Span option={'tiny'} $text_align={'left'} color={COLOR.red80} $margin={'12px 0 0 0'}>
          {t('MODAL.UNLOCK_DEVICE.ERROR_INCORRECT', { defaultValue: 'Enter correct string.' })}
        </Span>
      )}
      <Div display={'flex'} $margin={'24px auto 0 auto'} $gap={'16px'} $justify_content={'center'}>
        <Button
          option={'modal_cancel'}
          $margin={'0'}
          onClick={() => dispatch(setCloseModal())}
          $border={`1px solid ${COLOR.brand}`}
          className={'setting_unlock_device_cancel'}
        >
          <Span color={COLOR.brand} option={'small_bold'}>
            {t('BUTTON.CANCEL', { defaultValue: 'Cancel' })}
          </Span>
        </Button>
        <Button
          option={'modal_ok'}
          $margin={'0'}
          disabled={!TextLengthValid}
          $bgColor={ColorHandler(TextLengthValid, 'brand_black10')}
          onClick={TextValidConfirmHandler}
          className={'setting_unlock_device_ok'}
        >
          <Span color={ColorHandler(TextLengthValid, 'white_black30')} option={'small_bold'}>
            {t('BUTTON.OK', { defaultValue: 'OK' })}
          </Span>
        </Button>
      </Div>
    </>
  )
}
export default UnLockDeviceModal
